/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/common/date-time/date-time')
require('components/common/drop-menu-input/drop-menu-input')
require('components/base/tab/tab')
require('components/base/icon/icon')
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');

const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const confirm = require('components/base/pop/confirm');
const configPushMixin = require('../../mixin')
const ajaxHttp = require('appUtil/ajaxHttp.js')

const { tab: tabEvent, inputBox: inputBoxEvent } = require('components/config/event.json');
const { apiPath } = require('appService/api');

require('./ad-config-list.scss');
const template = require('./ad-config-list.tpl');

const adConfigList = {
  name: "ad-config-list",

  template,

  data() {
    return {
      thItems: ["序号", "广告图", "广告ID", "投放时间段", "广告名称",  "投放渠道", "广告形式", "投放位置", "广告类型", "覆盖范围", "状态",  "操作"],
      url: apiPath.configPush.adConfig.list,
      searchPlaceholder: '请选择'
    }
  },

  mixins: [configPushMixin],

  watch: {
    cityList(val) {
      this.$refs.tableData.fetch()
    }
  },

  events: {
    [inputBoxEvent.keyup](opt) {
      if (opt.event.keyCode === 13) {
        this.search()
      }

      return true;
    }
  },

  filters: {
    typeFilter(val) {
      switch (val) {
        case 1: return '应用内弹窗';
        case 2: return 'banner位';
        default: return '--'
      }
    },
    showPlaceFilter(val) {
      switch (val) {
        case 1: return '车况页';
        default: return '--'
      }
    },
    redirectTypeFilter(val) {
      switch (val) {
        case 1: return '外部链接';
        case 2: return 'H5';
        default: return '--'
      }
    },
    statusFilter(val) {
      switch (val) {
        case 0: return '投放中';
        case 1: return '已过期';
        case 2: return '未开始';
        case 3: return '已停止';
        default: return '--'
      }
    }
  },

  methods: {
    offlineDisplay(status) {
      return !(status === 3)
    },

    editDisplay(status) {
      return !(status === 3)
    },

    search () {
      const queryOpt = this.$refs.searchTool.search()
      this.$refs.tableData.query(queryOpt.queryValue).fetch()
    },

    offLine(id) {
      let self = this

      confirm({
        message: '确定下架广告？',
        cb(confirm) {
          confirm.hide()

          ajaxHttp(apiPath.configPush.adConfig.offLine, {
            data: {
              id: id
            }
          }).then((rtn) => {
            self.$refs.tableData.fetch()

            tip('下架成功！')
          }).catch((rtn) => {
            tip(rtn.error)
          })
        }
      })
    }
  }
}

module.exports = adConfigList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/ad-config/ad-config-list/ad-config-list.js